import React from "react";
import { Navigate } from "react-router-dom";

const AdminRoute = ({ component: Component, ...rest }) => {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/" />;

  try {
    // Decode token to get role (assuming JWT structure)
    const payload = JSON.parse(atob(token.split('.')[1]));
    const userRole = payload.role;
    if (userRole !== 'admin') return <Navigate to="/dashboard" />; // Redirect to dashboard if not admin
  } catch (error) {
    return <Navigate to="/" />;
  }

  return <Component {...rest} />;
};

export default AdminRoute;